var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('k8s.text_294')}}),_c(_vm.activedTab,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }